import { DateTime } from 'luxon'

export const sameDay = (a: DateTime, b: DateTime): boolean => a.hasSame(b, 'day')

export const toDateStrict = (value: Date | string): Date => (typeof value === 'string' ? new Date(value) : value)

const pad = (n: number): string => String(n).padStart(2, '0')

export const toISODate = (d: Date): string => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

// `updatedAt` arrives from the API as an ISO string (the zod coercion isn't applied to the raw query result),
// so accept both a Date and a string here.
export const toDateTime = (value: Date | string): DateTime => {
  const dt = typeof value === 'string' ? DateTime.fromISO(value) : DateTime.fromJSDate(value)
  return dt.setLocale('en')
}

export const formatDate = (updatedAt: Date) => {
  const date = new Date(updatedAt)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
}
